import React from 'react';
import classNames from 'classnames';
import style from './ContentTexts.module.scss';

var ContentTexts = function ContentTexts(_ref) {
  var contentTexts = _ref.contentTexts,
      theme = _ref.theme;
  var _contentTexts$heading = contentTexts.headingSize,
      headingSize = _contentTexts$heading === void 0 ? 1 : _contentTexts$heading,
      texts = contentTexts.texts;
  var HeadingEl = "h" + headingSize;
  return texts.map(function (item) {
    var size = item.size,
        color = item.color,
        title = item.title,
        description = item.description;
    return size && /*#__PURE__*/React.createElement("div", {
      key: size
    }, title && /*#__PURE__*/React.createElement(HeadingEl, {
      className: classNames(style["title-" + size], style["title--" + theme], style["text--" + color])
    }, title), description && /*#__PURE__*/React.createElement("p", {
      className: style["description-" + size]
    }, description));
  });
};

export default ContentTexts;